export { CenterMarkerPlugin } from './plugin/center-marker-plugin';
export { OpenLayerCenterMarkerPluginModule } from './open-layer-center-marker-plugin.module';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/open-layer-center-marker-plugin/index.ts